import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { ApiService, ConfirmService, FileService, PatientUploadedFile } from '@mmx/shared'
import { BehaviorSubject, finalize, from, switchMap } from 'rxjs'

@Component({
  selector: 'mmx-patient-file-view',
  templateUrl: './patient-file-view.component.html',
  standalone: false,
})
export class PatientFileViewComponent implements OnInit {
  public errorMessage: string
  public rotation = 0
  public zoomScale = 1
  public pdfUrl: SafeResourceUrl
  public textContent: string
  public jsonContent: any
  public loadingTextContent$ = new BehaviorSubject(false)

  get transform(): string {
    return `rotate(${this.rotation}deg) scale(${this.zoomScale})`
  }

  get isTextFile(): boolean {
    const extensions = ['.json', '.txt', '.csv']

    return extensions.includes(this.file.extension)
  }

  constructor(
    private dialogRef: MatDialogRef<PatientFileViewComponent>,
    @Inject(MAT_DIALOG_DATA) public file: PatientUploadedFile,
    private sanitizer: DomSanitizer,
    private restService: ApiService,
    private fileService: FileService,
    private confirmService: ConfirmService,
  ) {}

  ngOnInit(): void {
    if (this.file.extension === '.pdf') {
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.file.signedUrl,
      )
    }

    if (this.isTextFile) {
      this.loadingTextContent$.next(true)
      from(fetch(this.file.signedUrl))
        .pipe(
          switchMap((response) => response.text()),
          finalize(() => this.loadingTextContent$.next(false)),
        )
        .subscribe((textContent) => {
          if (this.file.extension === '.json') {
            this.jsonContent = JSON.parse(textContent)
          } else {
            this.textContent = textContent
          }
        })
    }
  }

  deleteFile(): void {
    this.confirmService
      .confirm('Are you sure you want to delete this file?')
      .subscribe((confirmation) => {
        if (confirmation) {
          this.restService
            .deletePatientFile({
              patientId: this.file.patientId,
              key: this.file.key,
            })
            .subscribe(() => {
              this.dialogRef.close(true)
            })
        }
      })
  }

  downloadFile(): void {
    this.fileService.saveAs({
      url: this.file.signedUrl,
      pdfFileName: this.file.fileName,
    })
  }

  rotate(direction: 'right' | 'left'): void {
    this.rotation += direction === 'right' ? 45 : -45
  }

  zoom(direction: 'in' | 'out'): void {
    this.zoomScale += direction === 'in' ? 0.1 : -0.1

    if (this.zoomScale <= 0.5) {
      this.zoomScale = 0.5
    }
  }
}
